// extracted by mini-css-extract-plugin
module.exports = {"brandColor1":"#140047","brandColor2":"#1F7EF2"};